function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';
var UndrawInTheOffice = function UndrawInTheOffice(_props) {
  var props = Object.assign({}, _props);
  var primaryColor = props.primaryColor || defaultProps.primaryColor;
  var style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 905.04 685",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 362.92,
    y1: 175.84,
    x2: 362.92,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), React.createElement("linearGradient", {
    id: "prefix__b",
    x1: 679.81,
    y1: 433,
    x2: 679.81,
    y2: 229.03,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__c",
    x1: 271.26,
    y1: 701.42,
    x2: 271.26,
    y2: 181,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__d",
    x1: 377.67,
    y1: 381.6,
    x2: 377.67,
    y2: 247.22,
    gradientTransform: "matrix(-1 0 0 1 652 0)",
    xlinkHref: "#prefix__a"
  })), React.createElement("path", {
    fill: "url(#prefix__a)",
    d: "M261.37 0v175.84h203.11V0H261.37z"
  }), React.createElement("path", {
    fill: "#535461",
    d: "M262.67 0h200.51v5.68H262.67z"
  }), React.createElement("path", {
    fill: "#ededf4",
    d: "M262.67 5.52h200.51v168.11H262.67z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M272.04 31.68h182.28v113.78H272.04z"
  }), React.createElement("circle", {
    cx: 266.4,
    cy: 2.76,
    r: 0.97,
    fill: "#fa595f"
  }), React.createElement("circle", {
    cx: 269.32,
    cy: 2.76,
    r: 0.97,
    fill: "#ffc74c"
  }), React.createElement("circle", {
    cx: 272.24,
    cy: 2.76,
    r: 0.97,
    fill: "#85d459"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M290.77 41.43v89.17h147.47"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.5,
    d: "M303.82 103.63h15.23v23.49h-15.23z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.7,
    d: "M329.92 82.75h15.23v44.37h-15.23z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.5,
    d: "M356.02 95.37h15.23v31.76h-15.23z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.8,
    d: "M382.13 75.79h15.23v51.33h-15.23z"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M408.23 57.52h15.23v69.6h-15.23z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M311.22 89.28l26.53-23.93 26.11 22.62 25.66-27.4 26.1-10.88"
  }), React.createElement("circle", {
    cx: 311.22,
    cy: 89.28,
    r: 3.05,
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 363.42,
    cy: 87.54,
    r: 3.05,
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 389.96,
    cy: 60.57,
    r: 3.05,
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 337.75,
    cy: 64.92,
    r: 3.05,
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 415.62,
    cy: 49.69,
    r: 3.05,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 450.26,
    cy: 556.36,
    rx: 450.26,
    ry: 128.64,
    fill: "#f5f5f5"
  }), React.createElement("path", {
    d: "M546.42 308.6s12.44-61.09 60-55.43c0 0 32.81 2.26 39.6 23.76v47.51z",
    fill: "#535461"
  }), React.createElement("path", {
    d: "M805.26 315.48c-5.58-.63-10.87-3-16.07-5.32-8.74-3.95-17.69-8.12-24.45-15.45-10.16-11-13.85-27.24-21-40.87a52.19 52.19 0 0 0-10.47-14.33 39.13 39.13 0 0 0-12.11-7.51 41 41 0 0 0-27.47-1l5-.83L677.3 237c-2.66.86-5.58 1.95-6.93 4.64s-.49 6.54 1.43 9 4.62 3.89 7.24 5.27l2.25 1.18a27.18 27.18 0 0 0 2.85 26.42v21.93a38.2 38.2 0 0 1-16.52 2.1 11.79 11.79 0 0 0-4.16 2.42c-2.61 2-5.92 6-7.27 13.39-2.27 12.46-28 54.9-30.68 59.26l-42 11 .25.24-.81.21s.33.31.85.86c-4.74.32-13.08.3-19.71-2.82-6.8-3.2-17.72.08-23.8 2.4a2.59 2.59 0 0 0-.37 4.66 58.9 58.9 0 0 0 26.77 7.63c10.26.54 18.66.61 24.41.55a6.41 6.41 0 0 1-1.29 4.94L640 405.1a27.48 27.48 0 0 0 4.15-2.91 35.67 35.67 0 0 0 7.87-8.72l10.81-14.13c.68 2.44 7.73 28.34 5.36 36.93l-2.53 9.52 14.78 1.53V427l44.73 6v-1h.08l.19-8.39 51.85-1.67s9-7.31 5.07-19-2.48-45.58-2.48-45.58a190.25 190.25 0 0 0-6.15-27.77 130.39 130.39 0 0 0 33.27-9.38c5.16-2.22 10.37-4.91 14-9.6-4.16 4.2-10.16 5.5-15.74 4.87z",
    transform: "translate(-147.48 -107.5)",
    fill: "url(#prefix__b)"
  }), React.createElement("path", {
    fill: "#fe5858",
    d: "M536.52 150.5h42v65h-42z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M536.52 150.5h42v65h-42z"
  }), React.createElement("path", {
    d: "M545.21 174.39a23.2 23.2 0 0 1 2.48 24.21c-6.42 13.8-2.49 33.67 2.68 36.7s25.7 7.16 32.11-1.66 6.05-34.3 3.94-38-17.75-6.83-17.08-27.72z",
    fill: "#f2b08d"
  }), React.createElement("path", {
    d: "M542.52 200.06s8.24 55.24 36.14 17.22l-2.31 104-50.45-6.73z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M542.45 201.05s8.24 55.24 36.14 17.22l-2.31 104-50.45-6.73z",
    fill: "#f1c413"
  }), React.createElement("path", {
    d: "M573.25 298.5s-15.17 1.92-25.67-2.66c0 0-20 5.41-18 10.11s47.89 5 47.89 5zM442.92 285.03s-13.19 2.12-22.71-2.36c-6.58-3.1-17.16.08-23.06 2.33a2.51 2.51 0 0 0-.36 4.51 57.06 57.06 0 0 0 25.93 7.39c19.36 1 31.9.32 31.9.32z",
    fill: "#f2b08d"
  }), React.createElement("path", {
    d: "M569.81 225.84l-7.68 74 7.12-1.26s11 9.13 1.48 14.62l55.07-1.7s8.72-7.08 4.91-18.45-2.4-44.16-2.4-44.16-5.67-41.5-16.93-43.67c0 0-22.77-4.46-36.07-19.26z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M570.8 225.94l-7.68 74 7.12-1.26s11 9.13 1.48 14.62l55.07-1.77s8.72-7.08 4.91-18.45-2.4-44.16-2.4-44.16-5.67-41.5-16.93-43.67c0 0-22.77-4.46-36.07-19.26z",
    fill: "#39447a"
  }), React.createElement("path", {
    d: "M549.12 192.01s-12.86 10.89-29.15 9.2c0 0-8.21 2.14-10.52 14.88s-29.93 57.76-29.93 57.76l-41 10.71s11.81 11.2 6.65 17.66l48.62-6.93a33.06 33.06 0 0 0 11.06-10.79l11-14.33s7.65 27.24 5.25 36l-2.45 9.23 14.32 1.49s.7-36.22 4.07-50.29c1.46-6.09 2.72-12.21 3.64-18.4 2.34-15.8 6-39.83 7.37-43z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M549.67 191.57s-12.86 10.93-29.15 9.2c0 0-8.21 2.14-10.52 14.88s-29.94 57.77-29.94 57.77l-41 10.71s11.81 11.2 6.65 17.66l48.62-6.93a33.06 33.06 0 0 0 11.1-10.82l11-14.33s7.65 27.24 5.25 36l-2.45 9.23 14.29 1.44s.7-36.22 4.07-50.29c1.46-6.09 2.72-12.21 3.64-18.4 2.34-15.8 6-39.83 7.37-43z",
    fill: "#39447a"
  }), React.createElement("path", {
    d: "M573.31 181.75c-2.35-3.71-4.36-5.29-4.13-12.36l-24.12 6.48a23.32 23.32 0 0 1 4.77 12.92 26.42 26.42 0 0 0 5.25 1.09c6.59.69 13.22-4.59 18.23-8.13z",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 705.43,
    cy: 269.74,
    r: 26.3,
    transform: "rotate(-84.08 572.054 297.78)",
    fill: "#f2b08d"
  }), React.createElement("path", {
    d: "M520.41 237.93s4.76 7 1.84 11.17-3.59 10.6-2.52 14.71M597.35 236.93s8.79 40.33 6.41 44.08M577.46 292.41s24.92 1.92 23.5-3.72",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M545.77 126.5a39.75 39.75 0 0 1 26.61 1 37.91 37.91 0 0 1 11.76 7.31 50.56 50.56 0 0 1 10.14 13.88c6.9 13.21 10.48 28.95 20.32 39.6 6.55 7.09 15.22 11.14 23.69 15 5 2.27 10.16 4.55 15.57 5.16s11.22-.65 15.25-4.71c-3.48 4.54-8.53 7.15-13.53 9.3a125.13 125.13 0 0 1-62.54 9.57c-6-.64-12-1.74-17.56-4.4-4-1.92-7.88-4.93-9.46-9.44-3.64-10.4 6.58-21.44 4.66-32.41-1-5.63-5.09-10-9.65-12.7s-9.65-4-14.52-5.8a136 136 0 0 1-14.93-7.13c-2.54-1.34-5.16-2.75-7-5.11s-2.75-6-1.38-8.69 4.14-3.66 6.71-4.5l20.73-6.71",
    fill: "#fe5858"
  }), React.createElement("path", {
    fill: "#ededf4",
    d: "M806.61 331.23l-423.1-35.07-54.3 11.31 3.39 75.8 3.71.45 4.21 113.81 415.19 74.66 44.12-37.33V411.47l5.65-3.31 1.13-76.93z"
  }), React.createElement("path", {
    opacity: 0.05,
    d: "M807.18 331.23l-1.13 76.93-45.82 21.49-.57-80.32 47.52-18.1z"
  }), React.createElement("path", {
    opacity: 0.05,
    d: "M799.83 411.55l.56 121.05-44.12 37.33 2.83-140.28 40.73-18.1z"
  }), React.createElement("path", {
    opacity: 0.05,
    d: "M336.87 388.24l422.57 51.57.22-9.78-423.1-45.63.31 3.84z"
  }), React.createElement("path", {
    opacity: 0.05,
    d: "M799.83 415.99v-4.44l-41.86 18.48v9.8l41.86-23.84z"
  }), React.createElement("path", {
    fill: "#f4f4f8",
    d: "M328.64 307.47l54.3-11.31 423.11 35.07-47.52 18.1-429.89-41.86z"
  }), React.createElement("ellipse", {
    cx: 849.73,
    cy: 475.54,
    rx: 32.57,
    ry: 11.96,
    fill: "#cd9494"
  }), React.createElement("ellipse", {
    cx: 849.73,
    cy: 474.21,
    rx: 16.62,
    ry: 6.1,
    opacity: 0.05
  }), React.createElement("path", {
    d: "M817.17 472.88s35.89 19.94 65.14 2.66c0 0-4 69.12-23.93 75.77h-26.59s-22.6-46.53-14.62-78.43z",
    fill: "#ff7361"
  }), React.createElement("path", {
    d: "M877.86 346.22c9.13 33.39-29.82 128.51-29.82 128.51s-82-62-91.09-95.43a62.68 62.68 0 0 1 120.91-33.08z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M877.86 346.22c9.13 33.39-29.82 128.51-29.82 128.51s-82-62-91.09-95.43a62.68 62.68 0 0 1 120.91-33.08z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M801.2 302.5s51 77 47.17 172.42",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M890.88 407.25s-46.26-25.16-40.36 67.73c0 0 38.59-1.38 52.28-32.86a27.3 27.3 0 0 0-11.2-34.48z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M891.64 407.41s-6 48.22-41.16 67.57",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M877.95 477.8c-1.35 15.9-6.86 65.29-23.56 70.85h-23.87c.76 1.7 1.22 2.66 1.22 2.66h26.59c19.94-6.65 23.93-75.77 23.93-75.77a48.4 48.4 0 0 1-4.31 2.26z",
    opacity: 0.05
  }), React.createElement("circle", {
    cx: 691.22,
    cy: 146.83,
    r: 37.33,
    fill: "#535461"
  }), React.createElement("circle", {
    cx: 691.22,
    cy: 146.83,
    r: 31.68,
    fill: "#ededf4"
  }), React.createElement("circle", {
    cx: 691.22,
    cy: 146.83,
    r: 2.26,
    fill: "#535461"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#535461",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M704.8 123.07l-13.58 23.76"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#535461",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M691.87 147.08l13.49 7.1"
  }), React.createElement("path", {
    d: "M350.92 668.57c-3.88-2.4-5.93-8.42-7-13.48l2.49-.85s-8.13-84.22-9.93-88.7-3.61-20.61-3.61-20.61l-2.93-87.84c13.49-4.9 19.16-14.38 21.07-18.53a23 23 0 0 0 1.72-3.83c-19-23.29-34.31-86-34.31-86l2.57-6.62 1.13-2.91c3.77 15.9 20.68 23 20.68 23l-.25-2.33c.67.33 1.08.51 1.14.53 3.55 2.63 7.32 4 10.85 2.7 11.08-4.23 10.9-23.62 10.84-25.78v-2L354.53 295a34.49 34.49 0 0 1-1.39 6c-.63-8.35-1.43-24 .49-32.89 2.13-9.88-18.7-3.08-24.11 8.57a21.32 21.32 0 0 0-16.52-8.6c-18.88-.81-31.79-12.74-34-14.89a56.76 56.76 0 0 1-1.11-6.19 29.41 29.41 0 0 0 9.43-26.59 15.15 15.15 0 0 0 1.42-.73c6.7-4 8.85-12.57 9.27-20.31v-1.26c.1-2.57-.49-5.75-3-6.27-3.29-.69-5.7 4.26-9 3.73a5 5 0 0 1-2.61-1.57c-2.27-2.25-3.8-5.14-6.05-7.39-3.36-3.36-8.14-5.07-12.9-5.48a48.6 48.6 0 0 0-14.2 1.33 23.45 23.45 0 0 0-7.31 2.48 8.73 8.73 0 0 0-4.4 6 9.83 9.83 0 0 0-.05 1.64c0 .83 0 1.68.07 2.51a6.81 6.81 0 0 1-.12 1.08c-.48 2.35-2.42 4.15-4.49 5.38s-4.38 2.09-6.33 3.5a16.62 16.62 0 0 0-6.11 9.67 26.73 26.73 0 0 0-.68 6.61 42.63 42.63 0 0 0 .35 6 63.81 63.81 0 0 0 5.57 19.32 27.33 27.33 0 0 0 3.62 6 33.62 33.62 0 0 0 7.31 6c1.1.74 2.41 1.5 3.67 1.09a3.19 3.19 0 0 0 1-.6c1.86-1.54 2.49-4 2.43-6.46 0 .26.08.53.11.78l.18.08a30.5 30.5 0 0 1 0 4.86c-1.67 1.42-13 10.86-25.68 16.08a31.3 31.3 0 0 0-18 19.94 69.43 69.43 0 0 1-8.5 18.44c-1.81 2.69-9.93 39.42-15.35 46.59-4.53 6 13.7 39 26.65 51.68l.58.55c3 3.14 5.76 5.33 8 6a41.09 41.09 0 0 1-.5-6.14c1.47 2 2.89 3.95 4.17 5.88-.53 2.83-1.15 5.61-1.87 8.32-9 34-3.61 34.94-3.61 34.94s.27.13.74.31c.47 1.37 1.06 1.48 1.06 1.48s.28.14.79.33c.22 39.21 6.43 82.1 6.43 82.1s-5.42 53.76-2.71 63.61 0 52 0 52l1.85.49c-1 5.32-3 11.85-7.27 15.64-8.13 7.17-16.25 19.71-5.42 23.29s25.28.9 27.08-9.86l.9-8.06 12.64-4.48-2.16-15c3.56-5.69-.55-34.28-.55-34.28s2.71-9.86 6.32-68.09c.1-1.64.22-3.23.34-4.81 0-.46.07-.91.11-1.36q.15-1.79.32-3.53c0-.4.08-.81.12-1.21.15-1.49.31-3 .48-4.41 0-.22.06-.44.08-.66q.23-1.85.47-3.64l.17-1.24q.23-1.63.48-3.2c0-.31.09-.62.14-.92q.32-2 .66-3.87l.16-.85q.27-1.49.56-2.94l.22-1.09q.31-1.52.63-3l.12-.56c.26-1.15.52-2.27.78-3.36l.21-.87q.31-1.25.62-2.45l.24-.91c.27-1 .54-2 .82-3v-.08c.28-1 .57-1.94.86-2.88l.25-.81q.33-1.05.66-2.06l.24-.72c.29-.87.58-1.72.87-2.54l.13-.35q.38-1.06.76-2.07l.26-.69q.34-.9.68-1.75l.21-.52q.43-1.07.86-2.07l.19-.44q.34-.79.68-1.54l.26-.57q.35-.76.69-1.48l.14-.31c.27-.57.54-1.11.8-1.63l.22-.42.58-1.13.23-.43.68-1.26v-.09l.69-1.21.2-.34a42.73 42.73 0 0 1 3.61-5.4S304.87 556.58 304 570s5.42 43 5.42 43 2.71 9.86 3.61 16.13c.77 5.33 5.45 26.18 6.83 32.33l.22 1v.11l.06.27v.24l-.88 10.87 11.74 7.17c6.32 17.92 19.86 17 30.7 12.54s-3.56-20.66-10.78-25.09zM337.7 304.14l-.14-.12v-.17zm-118.27 80.27c-.65-.54-1.32-1.14-2-1.78-.76-.8-1.5-1.65-2.19-2.55l.48.52c.7.66 1.4 1.28 2.07 1.83a306.72 306.72 0 0 0-1.24-30.77c.44-.74.84-1.39 1.2-1.93a297.17 297.17 0 0 1 1.68 34.68z",
    transform: "translate(-147.48 -107.5)",
    fill: "url(#prefix__c)"
  }), React.createElement("path", {
    d: "M244.54 247.31v.22l-.21-.31zm-27.31 132.5c-3.63-3.86-6.89-8.91-6.47-14.36.66-8.53 4.64-15.63 6.79-18.9a302.47 302.47 0 0 1 1.69 35.05c-.65-.54-1.33-1.15-2.01-1.79zm120.55-79.61l.15.27-.14-.12z",
    transform: "translate(-147.48 -107.5)",
    fill: "url(#prefix__d)"
  }), React.createElement("path", {
    d: "M193.36 533.5s.88 16.69 7.9 21.08 21.08 20.2 10.54 24.59-23.71 5.27-29.86-12.29l-11.42-7 1.76-22zM73.92 538.75s0 16.69-7.9 23.71-15.81 19.32-5.27 22.83 24.59.88 26.35-9.66l.88-7.9 12.29-4.39-3.51-24.59z",
    fill: "#1a2246"
  }), React.createElement("path", {
    d: "M180.19 327.11l3.51 106.26s1.76 15.81 3.51 20.2 9.66 86.93 9.66 86.93l-25.47 8.78s-6.15-27.22-7-33.37-3.51-15.81-3.51-15.81-6.15-29-5.27-42.15-29.86-88.7-29.86-88.7-18.44 22-22 79-6.15 66.74-6.15 66.74 4.39 30.74 0 34.25-26.35-2.63-26.35-2.63 2.63-41.27 0-50.93 2.63-62.35 2.63-62.35-16.65-115.83 4.43-138.71l91.33-6.12z",
    fill: "#3b477b"
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M191.6 540.5s-7.9-82.55-9.66-86.94-3.51-20.2-3.51-20.2l-3.51-106.25-10.4-38.29 5.17-.35 10.54 38.64 3.51 106.26s1.76 15.81 3.51 20.2 9.62 86.93 9.62 86.93l-25.47 8.78-.38-1.69zM92.37 549.29c4.39-3.51 0-34.25 0-34.25s2.63-9.66 6.15-66.74 22-79 22-79 .74 1.81 2 4.92c-5.47 9.26-16.09 32.23-18.66 74.12-3.51 57.08-6.15 66.74-6.15 66.74s4.39 30.74 0 34.25c-1.37 1.1-4.46 1.25-8.05.95a5.72 5.72 0 0 0 2.71-.99z"
  })), React.createElement("path", {
    d: "M131.01 119.86s-7 31.61 12.29 48.3-45.67 29.86-57.08 15.81 7.9-21.08 7.9-21.08 9.66-7.9 0-31.61z",
    fill: "#e0a17e"
  }), React.createElement("path", {
    d: "M136.28 154.99l-22.83 24.59-17.7-23.56-14.8 71 5.27 82.48s42.15 11.42 65.86-10.54l-7-76.4z",
    fill: "#f0f1f5"
  }), React.createElement("path", {
    d: "M138.03 306.04l3.49 11.46s-41.27 7-55.33 3.51l3.51-12.29s38.67 9.61 48.33-2.68z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M138.03 304.28l3.49 11.42s-41.27 7-55.33 3.51l3.51-12.29s38.67 9.65 48.33-2.64z",
    fill: "#1a2246"
  }), React.createElement("path", {
    d: "M130.13 148.84s13.17 14.05 33.37 14.93 22.83 25.47 22.83 25.47l7 65s-16.69-7-20.2-22.83l-4.39 11.42s14.93 61.47 33.37 84.31c0 0-7.9 26.35-46.54 22.83 0 0-21.08-9.66-20.2-34.25l-6.85-38.5a196.53 196.53 0 0 1-3-41z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M131.01 147.08s13.17 14.05 33.37 14.93 22.83 25.49 22.83 25.49l7 65s-16.69-7-20.2-22.83l-4.39 11.42s14.96 61.41 33.4 84.27c0 0-7.9 26.35-46.54 22.83 0 0-21.08-9.66-20.2-34.25l-6.9-38.44a196.53 196.53 0 0 1-3-41z",
    fill: "#293158"
  }), React.createElement("path", {
    d: "M98.27 153.11s-9.83 11.4-23.2 16.95a30.59 30.59 0 0 0-17.47 19.55 67.94 67.94 0 0 1-8.27 18.07c-1.76 2.63-9.66 38.64-14.93 45.67s21.08 51.81 32.49 55.33c0 0-4.39-24.59 13.17-27.22 0 0-15.81-9.66-14.93-21.08s7.9-20.2 7.9-20.2 6.15 44.79-2.63 78.16-3.51 34.25-3.51 34.25 36 17.56 30.74-65-.88-113.29-.88-113.29z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M65.14 306.91s-3.47-19.43 8.1-25.59c-.38 11.63-1.64 24.08-4.58 35.25-8.78 33.37-3.51 34.25-3.51 34.25a15.59 15.59 0 0 0 2.86 1c8.42 2.11 32.23 2.22 27.87-66-5.27-82.55-.88-113.29-.88-113.29l3.51-20.2s-11.83 10.4-25.2 15.95a30.6 30.6 0 0 0-17.47 19.55 68.3 68.3 0 0 1-8.27 18.07c-1.76 2.63-9.66 38.64-14.93 45.67-4.41 5.88 13.33 38.22 25.92 50.65 2.46 2.45 4.72 4.12 6.58 4.69zm-.49-41.61a13.94 13.94 0 0 1-1.26-6.69c.65-8.42 4.65-15.41 6.69-18.49.73-1.1 1.21-1.7 1.21-1.7a283.59 283.59 0 0 1 2.07 37.62c-3.07-2.54-6.78-6.36-8.71-10.73z",
    fill: "#293158"
  }), React.createElement("path", {
    d: "M110.81 150.6a28.86 28.86 0 0 1-12.65-2.9 56.83 56.83 0 0 0-4-14.66l36.88-11.42a70.58 70.58 0 0 0-.76 21.49 28.87 28.87 0 0 1-19.47 7.49z",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 110.81,
    cy: 119.86,
    r: 28.98,
    fill: "#e0a17e"
  }), React.createElement("path", {
    d: "M199.52 325.36c-18.44-22.83-33.37-84.31-33.37-84.31l4.37-11.42a26.8 26.8 0 0 0 1.62 4.93l-2.5 6.49s14.94 61.45 33.38 84.31c0 0-7.21 24-41.42 23.11 31.19-.82 37.92-23.11 37.92-23.11z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M203.9 199.78s-2.63-25.47 0-37.76-30.74 1.76-23.71 18.44 14.05 26.35 14.05 26.35z",
    fill: "#e0a17e"
  }), React.createElement("path", {
    d: "M204.77 188.36l10.54 39.52s.88 21.08-10.54 25.47-25.47-21.08-25.47-21.08l7-36.88s14.96 16.68 18.47-7.03z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M204.77 190.12l10.54 39.52s.88 21.08-10.54 25.47-25.47-21.08-25.47-21.08l7-36.88s14.96 16.68 18.47-7.03z",
    fill: "#293158"
  }), React.createElement("path", {
    d: "M204.77 190.12l10.54 39.52s.88 21.08-10.54 25.47-25.47-21.08-25.47-21.08l7-36.88s14.96 16.68 18.47-7.03z",
    opacity: 0.02
  }), React.createElement("path", {
    d: "M68.66 316.57c-8.78 33.37-3.51 34.25-3.51 34.25a15.59 15.59 0 0 0 2.86 1c8.85-17.81 10.35-46.9 9.58-72v-.61a453.72 453.72 0 0 0-4.07-47.38c-1 .87-2.18 3.87-3.41 8.29.73-1.1 1.21-1.7 1.21-1.7a283.59 283.59 0 0 1 2.07 37.62 26.16 26.16 0 0 1-.12 5.29c-.41 11.62-1.67 24.07-4.61 35.24z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M64.66 300.33l1 1.26a81.58 81.58 0 0 1 8.76 13.66c5.26 11.43 23.56-19.82 7.94-29-2.56-1.49-5-2.84-7.3-4l-1.77-.91c-7.22 3.82-8.62 12.76-8.63 18.99z",
    fill: "#e0a17e"
  }), React.createElement("path", {
    d: "M64.66 300.33l1 1.26s.41-16.36 9.41-19.35l-1.77-.91c-7.23 3.83-8.63 12.77-8.64 19zM111.16 111.88c1.63-.56 3.34-1.45 5-.9a5.67 5.67 0 0 1 2 1.36c2.29 2.16 4.55 4.67 7.62 5.34a14.73 14.73 0 0 0 5.7-.25c3.24-.57 6.57-1.18 9.39-2.86 6.52-3.89 8.6-12.33 9-19.91.14-2.55-.39-5.85-2.89-6.38-3.2-.68-5.54 4.18-8.77 3.65a4.88 4.88 0 0 1-2.54-1.54c-2.2-2.2-3.69-5-5.89-7.25a20.08 20.08 0 0 0-12.54-5.37 46.93 46.93 0 0 0-13.82 1.3 22.7 22.7 0 0 0-7.11 2.43 8.55 8.55 0 0 0-4.28 5.91c-.22 1.7.24 3.45-.1 5.12-.47 2.31-2.35 4.06-4.37 5.28s-4.26 2-6.16 3.43a16.31 16.31 0 0 0-5.94 9.47 32.07 32.07 0 0 0-.32 11.36 62.91 62.91 0 0 0 5.38 18.94 26.83 26.83 0 0 0 3.52 5.87 32.76 32.76 0 0 0 7.11 5.9c1.07.72 2.35 1.47 3.57 1.07a3.1 3.1 0 0 0 1-.59c2.49-2.08 2.73-5.85 2-9s-2.11-6.2-2.26-9.44a4.54 4.54 0 0 1 .52-2.63 11.61 11.61 0 0 1 1.76-1.77 10.61 10.61 0 0 0 2-3.3c1.33-3 2.68-6.15 3-9.46a12.76 12.76 0 0 0-1.69-7.79 10.08 10.08 0 0 0 10.11 2.01z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M111.16 110.88c1.63-.56 3.34-1.45 5-.9a5.67 5.67 0 0 1 2 1.36c2.29 2.16 4.55 4.67 7.62 5.34a14.73 14.73 0 0 0 5.7-.25c3.24-.57 6.57-1.18 9.39-2.86 6.52-3.89 8.6-12.33 9-19.91.14-2.55-.39-5.85-2.89-6.38-3.2-.68-5.54 4.18-8.77 3.65a4.88 4.88 0 0 1-2.54-1.54c-2.2-2.2-3.69-5-5.89-7.25a20.08 20.08 0 0 0-12.54-5.37 46.93 46.93 0 0 0-13.82 1.3 22.7 22.7 0 0 0-7.11 2.43 8.55 8.55 0 0 0-4.28 5.91c-.22 1.7.24 3.45-.1 5.12-.47 2.31-2.35 4.06-4.37 5.28s-4.26 2-6.16 3.43a16.31 16.31 0 0 0-5.94 9.47 32.07 32.07 0 0 0-.32 11.36 62.91 62.91 0 0 0 5.38 18.94 26.83 26.83 0 0 0 3.52 5.87 32.76 32.76 0 0 0 7.11 5.9c1.07.72 2.35 1.47 3.57 1.07a3.1 3.1 0 0 0 1-.59c2.49-2.08 2.73-5.85 2-9s-2.11-6.2-2.26-9.44a4.54 4.54 0 0 1 .52-2.63 11.61 11.61 0 0 1 1.76-1.77 10.61 10.61 0 0 0 2-3.3c1.33-3 2.68-6.15 3-9.46a12.76 12.76 0 0 0-1.69-7.79 10.08 10.08 0 0 0 10.11 2.01z",
    fill: "#463e3b"
  }));
};
UndrawInTheOffice.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawInTheOffice;